<template>
    <div class="col-sm-12">
        <h3>{{ $t('ins_wizard.select_vehicle') }}</h3>
        <div
            id="vehicle-list"
            class="col-sm-12 nopads"
        >
            <div
                v-for="result of results"
                :key="result.id"
                class="inspection-selector"
                @click.stop="$emit('onVehicleSelected', result)"
            >
                <div class="col-sm-12 nopads">
                    <div class="item-img-cont">
                        <font-awesome-icon
                            class="text-light"
                            :icon="getIcon(result.vehicle_type)"
                        />
                    </div>
                    <div class="item-text-cont">
                        <span class="item-title text-light">{{ result.license_plate }}</span>
                        <span class="item-text text-light" style="min-height: 1em">{{ result.make }} {{ result.vehicle_model }}</span>
                    </div>

                </div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>

import {restApi} from "../../mixins/RestApiMixin"
import {vehicleHelper} from '../../mixins/VehicleMixin'

export default {
    name: 'vehicle-selector',
    mixins: [restApi, vehicleHelper],
    data() {
        return {
            results: [],
            loading: false
        }
    },
    created() {
        this.fetchVehicles()
    },
    methods: {
        fetchVehicles: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.vehicleUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        }
    }
}
</script>
